import React, { Component } from 'react';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import Alert from 'react-bootstrap/lib/Alert';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import ProductTypes from '../ProductTypes';
import OrderStorageStatus from '../../components/Status/OrderStorageStatus';
import { connect } from 'react-redux';
import rehypeRaw from "rehype-raw";
import { Spin } from 'antd';
import Currency from '../Currency';
import { InvoiceChain, buildSearchInvoiceChainItems } from '../../utils/invoiceChain';

const mapStoreToProps = (store) => {
    return {
        user: store.authentification.user,
    };
};

class SearchBar extends Component {

    state = {
        keyword: '',
        data: [],
        next_page: '',
        current_page: 1,
        total: '',
        SearchCheckbox: 0,
        loading: false,
        search_time: '',
    }


    componentDidMount() {
        // 定时检测关键字
        setTimeout(this.searchTimer, 0);
    }

    // 定时监测搜索关键字
    searchTimer = () => {
        this.setState({
            timer: setInterval(() => {
                if (this.props.keyword !== this.state.keyword || this.props.SearchCheckbox != this.state.SearchCheckbox) {
                    this.setState({
                        keyword: this.props.keyword,
                        SearchCheckbox: this.props.SearchCheckbox
                    });
                    this.Search();
                }
            }, 100),
        });
    }

    Search = (event) => {
        let tm = new Date().getTime();
        this.setState({
            search_time: tm
        });

        let keyword = this.props.keyword;
        let SearchCheckbox = this.props.SearchCheckbox;
        if (keyword == '') {
            this.setState({
                data: [],
                next_page: '',
                current_page: 1,
                total: '',
            });
            return;
        }
        // search
        const cookies = new Cookies();
        var token = cookies.get('token');
        this.setState({
            loading: true
        });
        axios.get(window.api + 'product/search?token=' + token + '&keyword=' + keyword + '&SearchCheckbox=' + SearchCheckbox)
            .then((response) => {
                if (tm == this.state.search_time) {
                // console.log(response.data);
                    this.setState({
                        data: response.data.data,
                        next_page: response.data.next_page,
                        total: response.data.total,
                        loading: false,
                    });
                }
                // {
                //     "data": [
                //         {
                //             "_index": "dev",
                //             "_type": "aoi_products",
                //             "_id": "63628",
                //             "_score": 15.3534220000000001249418346560560166835784912109375,
                //             "_source": {
                //                 "id": 63628,
                //                 "brand": 6722,
                //                 "brand_name": "PMP ARCOS",
                //                 "type": 0,
                //                 "name": "722031-501 (21002-0358)",
                //                 "oid": 22627,
                //                 "order_name": "PO-210521-XMSD1504",
                //                 "iid": 1817,
                //                 "invoice_name": "AOI21346",
                //                 "client": 240,
                //                 "client_name": "厦门士德工贸有限公司",
                //                 "resource": 5985,
                //                 "resource_name": "PMP ARCOS",
                //                 "amount": 2,
                //                 "price": 1631,
                //                 "contract": 8954,
                //                 "contract_name": "PC08954",
                //                 "contract_client_order_number": null,
                //                 "ztn": "85389091",
                //                 "description": "Ctrl module",
                //                 "description_cn": null
                //             }
                //         }
                //     ],
                //     "next_page": ""
                // }
            })
            .catch((error) => {
            })
    }

    render() {
        const { user } = this.props;

        if (this.props.keyword == '') {
            return '';
        }

        return (
            <div>
                {React.Component.prototype.$intl.get('搜索到')} {this.state.total} {React.Component.prototype.$intl.get('条数据')}
                <br />
                <br />
                <Spin spinning={this.state.loading} size='large'>
                    {this.state.data.map((hit, p) =>
                        <Alert key={hit._id || p} bsStyle="info" className='search-result-alert' style={{ borderRadius: "10px", border: "0px", padding: "20px", marginBottom: "15px" }}>
                            <Row>
                                <Col lg={4}>
                                    <p>ID: {hit._source.oid}</p>
                                    <p>{React.Component.prototype.$intl.get('订单')}: <Link to={'/order/' + hit._source.oid} target="_blank">
                                        {hit._source.buy == 7 ?
                                            <span style={{ color: 'green' }}>{hit._source.order_name}</span>
                                        :
                                        <>{hit._source.order_name}</>
                                        }
                                    </Link></p>
                                    {user.group != 9 ? <>
                                        <p>{React.Component.prototype.$intl.get('客户')}: <Link to={'/client/' + hit._source.client} target="_blank">{hit._source.client_name}</Link></p>
                                        <p>{React.Component.prototype.$intl.get('渠道')}: <Link to={'/resource/' + hit._source.resource} target="_blank">{hit._source.resource_name}</Link></p>
                                    </> :
                                        <>
                                            <p>{React.Component.prototype.$intl.get('客户')}: {hit._source.client_name}</p>
                                            <p>{React.Component.prototype.$intl.get('渠道')}: {hit._source.resource_name}</p>
                                        </>
                                    }
                                </Col>
                                <Col lg={6}>
                                    {user.group != 9 ? <>
                                        <p><Link to={'/brand/' + hit._source.brand} target="_blank">{hit._source.brand_name}</Link> {hit._source.name}</p>
                                    </> :
                                        <>
                                            <p>{hit._source.brand_name} {hit._source.name}</p>
                                        </>
                                    }
                                    <p><ProductTypes type={hit._source.type} /></p>
                                    {hit._source.ztn !== '0' ? <p>{hit._source.ztn}</p> : null}
                                    {hit._source.description !== ' ' ? <ReactMarkdown children={hit._source.description} rehypePlugins={[rehypeRaw]} /> : null}
                                    {buildSearchInvoiceChainItems(hit._source).length > 0 ? <p><InvoiceChain items={buildSearchInvoiceChainItems(hit._source)} linkMode='router' /></p> : null}
                                    {hit._source.contract !== '0' ? <p><Link to={'/contract/' + hit._source.contract} target="_blank">{hit._source.contract_name}</Link></p> : null}
                                    <OrderStorageStatus status={hit._source.storage_status} />

                                    型号 {hit._source.name} 到货状态：
                                    {(hit._source.delivery_status && !hit._source.delivered_quantity) ?
                                        <span style={{ color: '#FFF' }}>到货</span>
                                        : null}
                                    {(hit._source.delivery_status && hit._source.delivered_quantity && hit._source.amount > hit._source.delivered_quantity) ?
                                        <span style={{ color: '#f0ad4e' }}>到货</span>
                                        : null}
                                    {!hit._source.delivery_status ?
                                        <span style={{ color: 'red' }}>未到货</span>
                                        : null}
                                    {(hit._source.delivery_status && hit._source.delivered_quantity && hit._source.amount == hit._source.delivered_quantity) ?
                                        <span style={{ color: '#FFF' }}>到货</span>
                                        : null}
                                </Col>
                                <Col lg={2}>
                                    {user.group != 9 ? <>
                                        <p>{React.Component.prototype.$intl.get('价格')}: {hit._source.price} <Currency currency={hit._source.price_currency}/></p>
                                        <p>{React.Component.prototype.$intl.get('数量')}: {hit._source.amount}</p>
                                        <p>{React.Component.prototype.$intl.get('总价')}: {(hit._source.amount * hit._source.price).toFixed(2)} <Currency currency={hit._source.price_currency}/></p>
                                    </> : <>
                                        <p>{React.Component.prototype.$intl.get('数量')}: {hit._source.amount}</p>
                                    </>}
                                </Col>
                            </Row>
                        </Alert>
                    )}
                </Spin>
            </div>
        );
    }
}

// export default SearchBar;
export default connect(mapStoreToProps)(SearchBar);
